import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const Watchers = {

    data() {
        return {
            notyf,
            rest_api_rooms: 'rooms_advanced_search',
            rest_api_cost_center_personnel: 'personels'
        }
    },

    watch: {
        form_data: {
            handler(newVal)
            {
                let keys = Object.keys(newVal);
                keys.forEach(item => 
                {
                    this.$refs.main_table.params[item] = newVal[item]
                });

                this.$refs.main_table.params['page'] = 1;
                this.is_mounted++
                this.fetchMainList(this.$refs.main_table.params)

            },
            deep: true
         },

        async 'form_data.building_id'(val)
        {
            if(this.module_name == 'rooms' || this.module_name == 'areas' || this.module_name == 'room_tasks')
            {
                if(this.is_mounted > 1)
                {
                    this.form_data.level_id = ''
                }

                if(val)
                {
                    let http_request = {
                        id:             val,
                        type_request:   'building',
                    }

                    const response = await this.get(`${this.rest_api_rooms}/${JSON.stringify(http_request)}`);
                    if(response.status)
                    {
                        if(response.data.length)
                        {
                            this.array_options = {...this.array_options, level_id:  response.data}

                            notyf.success('Levels available for the selected building')
                        }
                        else
                        {
                            this.array_options['level_id'] = []
                            notyf.error('No levels available for the selected building')
                        }
                    }
                    else
                    {
                        this.error_handling(response)
                    }
                }
                else
                {
                    this.array_options['level_id'] = []
                }
            }
        },

        async 'form_data.level_id'(val)
        {
            if(this.module_name == 'rooms' || this.module_name == 'room_tasks')
            {
                if(this.is_mounted > 1)
                {
                    this.form_data.area_id = ''
                }

                if(val)
                {
                    let http_request = {
                        id:             val,
                        type_request:   'level',
                    }
                    const response = await this.get(`${this.rest_api_rooms}/${JSON.stringify(http_request)}`);

                    if(response.status)
                    {
                        if(response.data.length)
                        {
                            this.array_options = {...this.array_options, area_id:  response.data}

                            notyf.success('Areas available for the selected level')
                        }
                        else
                        {
                            this.array_options['area_id'] = []
                            notyf.error('No areas available for the selected level')
                        }
                    }
                    else
                    {
                        this.error_handling(response)
                    }
                }
                else
                {
                    this.array_options['area_id'] = []
                }
            }
        },
        
        async 'form_data.radio'(val)
        {
            if(this.module_name == 'rooms' || this.module_name == 'room_tasks')
            {
                this.form_data.task_id = ''
                this.form_data.frequency = ''
                this.array_options['task_id'] = []

                let found_index = this.form_format.findIndex(item => item.model_name == 'task_id')
                let frequency_id_index = this.form_format.findIndex(item => item.model_name == 'frequency_id')
                let frequency_index = this.form_format.findIndex(item => item.model_name == 'frequency')

                if(val == 'projects')
                {
                    this.form_format[frequency_id_index].disabled = false
                    this.form_format[frequency_index].disabled = true
                }
                else if(val == 'daily' || val == 'policing')
                {
                    this.form_format[frequency_id_index].disabled = true
                    this.form_format[frequency_index].disabled = false
                }
                else
                {
                    this.form_format[frequency_id_index].disabled = true
                    this.form_format[frequency_index].disabled = true

                    if(found_index > -1)
                    {
                        this.form_format[found_index].disabled = true
                    }
                }

                if(val && val != 'all')
                {
                    if(found_index > -1)
                    {
                        this.form_format[found_index].disabled = false
                    }

                    let http_request = {
                        id:             val,
                        type_request:   'tasks',
                    }

                    const response = await this.get(`${this.rest_api_rooms}/${JSON.stringify(http_request)}`);
                    if(response.status)
                    {
                        if(response.data.length)
                        {
                            this.array_options = {...this.array_options, task_id:  response.data}
                            notyf.success('Tasks available for the selected type')
                        }
                        else
                        {
                            this.array_options['task_id'] = []
                            notyf.error('No tasks found')
                        }
                    }
                    else
                    {
                        this.error_handling(response)
                    }
                }
            }
        },
        async 'form_data.cost_center_id'(val)
        {
            if(this.module_name == 'cost_center_personnel')
            {
                if(this.is_mounted > 1)
                {
                    this.form_data.cost_center_department_id = ''
                }

                if(val)
                {
                    let http_request = {
                        request_id:             val,
                        department_request:   'true',
                    }

                    const response = await this.get(`${this.rest_api_cost_center_personnel}/${JSON.stringify(http_request)}`);
                    if(response.status)
                    {
                        if(response.data.departments.length)
                        {
                            this.array_options = {...this.array_options, cost_center_department_id:  response.data.departments}
                            notyf.success('Departments available for the selected cost center')
                        }
                        else
                        {
                            this.array_options['cost_center_department_id'] = []
                            notyf.error('No departments available for the selected cost center')
                        }
                    }
                    else
                    {
                        this.error_handling(response)
                    }
                }
                else
                {
                    this.array_options['cost_center_department_id'] = []
                }
            }
        },

        
    },
}

export default Watchers